import { useQuery } from 'react-query'
import { ApiPermission } from './_models'
import { getAuthPermissions, getRbacPermissions } from './_requests'

export const AUTH_PERMISSIONS_QUERY_KEY = 'auth-permissions'
export const RBAC_PERMISSIONS_QUERY_KEY = 'rbac-permissions'

export const useAuthPermissions = (enabled = true) => {
  return useQuery(
    [AUTH_PERMISSIONS_QUERY_KEY],
    async (): Promise<ApiPermission[]> => {
      const { data } = await getAuthPermissions()
      return data?.data?.permissions || []
    },
    {
      enabled,
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      retry: 1,
    }
  )
}

export const useRbacPermissions = () => {
  return useQuery(
    [RBAC_PERMISSIONS_QUERY_KEY],
    async () => {
      const { data } = await getRbacPermissions()
      return data?.data?.results || []
    },
    {
      staleTime: 5 * 60 * 1000,
      cacheTime: 10 * 60 * 1000,
      retry: 1,
    }
  )
}
